<template>
  <div class="step-body step-genres">
    <div class="genre-counter">
      <span class="counter-num">{{ selected.length }}</span>
      <span class="counter-of">/ {{ maxGenres }}</span>
      <span class="counter-text">{{ counterText }}</span>
      <span v-if="errors.genres" class="counter-error">
        <LtIcon name="info" :size="14" />{{ errors.genres }}
      </span>
    </div>

    <div class="genre-grid">
      <button
        v-for="g in genres"
        :key="g.id"
        type="button"
        class="genre-chip"
        :class="{ on: isOn(g.id), disabled: isDisabled(g.id) }"
        :disabled="isDisabled(g.id)"
        @click="toggle(g.id)"
      >
        <span class="genre-chip-check">
          <LtIcon v-if="isOn(g.id)" name="check" :size="14" />
        </span>
        <span class="genre-chip-label">{{ g.name }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import LtIcon from './LtIcon.vue';
import { MAX_GENRES } from './data.js';

export default {
  name: 'StepGenres',
  components: { LtIcon },
  props: {
    data:   { type: Object, required: true },
    errors: { type: Object, default: () => ({}) },
  },
  emits: ['update'],
  computed: {
    genres()    { return this.$store.genres || []; },
    maxGenres() { return MAX_GENRES; },
    selected()  { return this.data.genres || []; },
    remaining() { return this.maxGenres - this.selected.length; },
    counterText() {
      return this.remaining > 0
        ? `אפשר לבחור עוד ${this.remaining}`
        : 'הגעתם למקסימום';
    },
  },
  methods: {
    isOn(id)       { return this.selected.includes(id); },
    isDisabled(id) { return !this.isOn(id) && this.selected.length >= this.maxGenres; },
    toggle(id) {
      if (this.isOn(id)) {
        this.$emit('update', { genres: this.selected.filter((x) => x !== id) });
      } else if (this.selected.length < this.maxGenres) {
        this.$emit('update', { genres: [...this.selected, id] });
      }
    },
  },
}
</script>
